import axiosClient from "../../network";

export default class faqService {
  static getfaqData(params) {
    return axiosClient
      .get("user/getFAQ", {
        params
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }
}
